'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _CheckboxConstants = require('./CheckboxConstants');

var _Functions = require('../core/Functions');

var _underscore = require('../utils/underscore');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderIndicator = (0, _memoize2.default)(function (color) {
  return _react2.default.createElement(
    'span',
    {
      className: 'private-checkbox__indicator private-radio__indicator',
      style: { color: color }
    },
    _react2.default.createElement(
      'svg',
      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 22 22' },
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd', transform: 'translate(1 1)' },
        _react2.default.createElement('circle', {
          cx: '10',
          cy: '10',
          r: '10',
          className: 'private-radio__circle',
          stroke: 'currentColor',
          strokeWidth: '1.5'
        }),
        _react2.default.createElement('circle', { className: 'private-radio__dot', id: 'a', cx: '10', cy: '10', r: '5' })
      )
    )
  );
});

exports.default = _react2.default.createClass({
  displayName: 'UIRadioInput',

  propTypes: {
    alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
    'aria-labelledby': _react.PropTypes.string,
    checked: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    color: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    description: _react.PropTypes.node,
    descriptionLayout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
    disabled: _react.PropTypes.bool,
    inline: _react.PropTypes.bool,
    labelClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _react.PropTypes.oneOf(['default'])]),
    text: _react.PropTypes.node,
    value: _react.PropTypes.any
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alignment: 'start',
      descriptionLayout: 'vertical'
    };
  },
  handleChange: function handleChange(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onChange = _props.onChange,
        readOnly = _props.readOnly;

    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    (0, _Functions.callIfPossible)(onChange, event);
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        alignment = _props2.alignment,
        ariaLabelledBy = _props2['aria-labelledby'],
        checked = _props2.checked,
        children = _props2.children,
        className = _props2.className,
        color = _props2.color,
        defaultChecked = _props2.defaultChecked,
        description = _props2.description,
        descriptionLayout = _props2.descriptionLayout,
        disabled = _props2.disabled,
        id = _props2.id,
        inline = _props2.inline,
        labelClassName = _props2.labelClassName,
        name = _props2.name,
        __onChange = _props2.onChange,
        readOnly = _props2.readOnly,
        size = _props2.size,
        text = _props2.text,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['alignment', 'aria-labelledby', 'checked', 'children', 'className', 'color', 'defaultChecked', 'description', 'descriptionLayout', 'disabled', 'id', 'inline', 'labelClassName', 'name', 'onChange', 'readOnly', 'size', 'text', 'value']);

    if (children && text) {
      _devLogger2.default.warn({
        message: 'UIRadioInput: `children` or `text` should be specified, not both.',
        key: 'UIRadioInput: children and text given'
      });
    }

    var computedText = children || text;
    var computedDescId = description ? (0, _underscore.uniqueId)('checkbox-') : null;

    if (!name) {
      _devLogger2.default.warn({
        message: 'UIRadioInput: `name` must be specified.',
        key: 'UIRadioInput: no name'
      });
    }

    return _react2.default.createElement(
      _FieldsetContext.Consumer,
      null,
      function (_ref) {
        var fieldSize = _ref.size,
            fieldDisabled = _ref.disabled;

        var longhandSize = (0, _tshirtSize.toLonghandSize)(size || fieldSize);
        var computedDisabled = disabled || fieldDisabled;

        return _react2.default.createElement(
          'div',
          _extends({}, rest, {
            className: (0, _classNames2.default)('private-radio', className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[longhandSize], {
              'private-checkbox': computedText,
              'private-checkbox--disabled': computedDisabled,
              'private-checkbox--readonly': readOnly,
              'private-checkbox--inline': inline,
              'private-checkbox--flush': !computedText,
              'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
            })
          }),
          _react2.default.createElement(
            'label',
            {
              className: (0, _classNames2.default)('private-checkbox__label', labelClassName)
            },
            _react2.default.createElement(
              'span',
              { className: 'private-checkbox__inner' },
              _react2.default.createElement('input', {
                'aria-describedby': computedDescId,
                'aria-labelledby': ariaLabelledBy,
                checked: checked,
                className: (0, _classNames2.default)('sr-only', 'private-checkbox__input'),
                defaultChecked: defaultChecked,
                disabled: computedDisabled,
                id: id,
                name: name,
                onChange: _this.handleChange,
                readOnly: readOnly,
                type: 'radio',
                value: value
              }),
              renderIndicator(color),
              computedText ? _react2.default.createElement(
                'span',
                {
                  className: (0, _classNames2.default)('private-checkbox__text', {
                    'private-checkbox__text--small': longhandSize === 'small'
                  })
                },
                computedText
              ) : null
            )
          ),
          description && _react2.default.createElement(
            'span',
            { className: 'private-checkbox__desc', id: computedDescId },
            description
          )
        );
      }
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UIRadioInput.js
// module id = 571
// module chunks = 3 4 5